module.exports = [{
      plugin: require('C:/Users/wywywywy/Projects/wyblog/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Wy's Blog","short_name":"wyblog","start_url":"/","background_color":"#7B8484","theme_color":"#7e9aa7","display":"minimal-ui","icon":"src/images/android-chrome-512x512.png"},
    },{
      plugin: require('C:/Users/wywywywy/Projects/wyblog/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-127170497-2","head":false,"anonymize":true,"respectDNT":true,"exclude":[],"pageTransitionDelay":0,"cookieDomain":"wywywywy.com"},
    }]
